module.exports = __webpack_public_path__ + "img/art-35.a72fbd92.png";